var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05762 1.81445C8.97278 3.09058 10.2234 4.03565 11.4277 3.60547L11.8799 3.44336L12.8848 5.18555C12.4305 5.55635 12.177 6.06955 12.123 6.59961L10.2969 7.18457C10.3158 7.06411 10.3291 6.94119 10.3291 6.81543C10.3291 5.50657 9.26774 4.44539 7.95898 4.44531C6.65016 4.44531 5.58887 5.50652 5.58887 6.81543C5.58887 6.93131 5.60013 7.04482 5.61621 7.15625L3.98242 6.63379C3.93607 6.09173 3.68363 5.56427 3.21973 5.18555L4.22461 3.44336L4.67578 3.60547C5.88023 4.03607 7.13172 3.09074 7.04688 1.81445H9.05762Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 9.04004V15.1201L2 13.4141V7.33398L7.33301 9.04004ZM14 13.4141L8.66699 15.1201V9.04004L14 7.33398V13.4141Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingIcon);
export default __webpack_public_path__ + "static/media/ProcessingIcon.4614ac5a8311a5dc0fd4ed933b2b945e.svg";
export { ForwardRef as ReactComponent };